import { IStore } from '..';
import { TPopUpValues } from '../../app/types/screenPopUpsTypes';

export const getPopUps = (state: IStore): TPopUpValues[] | null => state.screenPopUpsReducer.popUps;

export const getIsInCall = (state: IStore): boolean  => state.screenPopUpsReducer.isInCall;
  